import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { LegalFormApi } from '@/modules/counterparty/api/legal-form.api.ts';

export class LegalFormQueryOptions {
  static BASE_KEY = 'legal-form';

  static getList(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, LegalFormQueryOptions.BASE_KEY],
      queryFn: (meta) => LegalFormApi.getList(signal ?? meta.signal),
    });
  }
}
